import { Icon } from "@/utils/icons";

export const FacilityCard = ({ facility }) => (
  <article
    className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
    data-testid={`facility-card-${facility.slug}`}
  >
    <div className="relative overflow-hidden">
      <img
        src={facility.image}
        alt={`${facility.name} at the hospital`}
        loading="lazy"
        className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-xl bg-white/95 text-navy-800 shadow">
        <Icon name={facility.icon} className="h-5 w-5" aria-hidden="true" />
      </span>
    </div>
    <div className="p-6">
      <h3 className="font-heading text-lg font-semibold text-navy-900">{facility.name}</h3>
      <p className="mt-2 text-sm leading-relaxed text-slate-600">{facility.description}</p>
    </div>
  </article>
);
